import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import PDP from '../assets/equipment/3.12-PDP.png';
import PDPLoc from '../assets/equipment/pdp-loc.png';
import TransformerStand from '../assets/equipment/3.13-transformer-stand.png';
import TransformerLoc from '../assets/equipment/transformer-loc.png';
import PAC from '../assets/equipment/3.14-PAC.png';
import PACLoc from '../assets/equipment/pac-loc.png';
import ServerPanel from '../assets/equipment/3.15-server-panel.png';
import SPLoc from '../assets/equipment/sp-loc.png';
import TriggerPanel from '../assets/equipment/3.17-trigger-panel.png';
import TPLoc from '../assets/equipment/tp-loc.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { BsPencil } from 'react-icons/bs';
import PDPDrawing from '../../../../components/Tables/Tabledata/Drawings/IE-2470-110.pdf';
import PACDrawing from '../../../../components/Tables/Tabledata/Drawings/IE-2470-111.pdf';
import SPDrawing from '../../../../components/Tables/Tabledata/Drawings/IE-2470-112.pdf';
import TPDrawing from '../../../../components/Tables/Tabledata/Drawings/TP.zip';

const WarrenAssemblies = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('PDP');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Electrical Panels</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 equipment-element">
								<Tab eventKey="PDP" title="PDP">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>POWER DISTRIBUTION PANEL (PDP)</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>

											<p>
												There is (1) Power Distribution Panel (<b>PDP</b>) for the SMARTInspect cell. The system <b>PDP</b> receives 480VAC 3-phase 60Hz. power supplied from the plant control bus electrical drop. The <b>PDP</b> also distributes 480 VAC to the Transformer Stand, and 240/120/24 VAC to various panels and components. The <b>PDP</b> has a lockable electrical power disconnect for switching main power ON / OFF. The system’s electrical ECPL Lockout/Tagout (<b>LOTO</b>) placard is mounted on the front.
											</p>
											<figure style={{ width: '24vw', margin: '20px' }}>
												<img src={PDPLoc} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Power Distribution Panel Location</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<figure style={{ width: '42vw', margin: '20px' }}>
												<img src={PDP} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 2: Power Distribution Panel</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Transformer Stand" title="Transformer Stand">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex justify-content-start">
												<h2>TRANSFORMER STAND</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>

											<p>On the transformer stand are four (4) transformers used to reduce incoming 480 VAC plant voltage to either 120 or 240 VAC for various electrical components.</p>
											<p>Note that the 206T transformer is wired above the main disconnect and remains live when the disconnect switch is in the OFF position.</p>

											<ul>
												<li>
													<b>206T</b> - Allen-Bradley 5 kVA transformer 480 / 120 VAC – 120 VAC Power Distribution - Power Supply (PAC)
												</li>
												<li>
													<b>236T</b> - Sola 7.5 kVA transformer 480 / 120 VAC – UPS1 Power Supply (SP)
												</li>
												<li>
													<b>306T</b> - 7.5 kVA transformer 480 / 120 VAC – 120 VAC Power Distribution – Power Supply (MON), HMI, Lights, Programming Outlet
												</li>
												<li>
													<b>316T</b> - 10 kVA 480 / 240 VAC – Servers 1~4 Power (SP)
												</li>
											</ul>

											<figure style={{ width: '28vw', margin: '20px' }}>
												<img src={TransformerLoc} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Transformer Location</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<figure style={{ width: '27vw', margin: '20px' }}>
												<img src={TransformerStand} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 2: Transformer Stand</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="PAC" title="PAC">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '50vw' }}>
											<div class="d-flex">
												<h2>PROGRAMMABLE AUTOMATION CONTROLLER (PAC)</h2>{' '}
												<a href={PACDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>
												The Programmable Automation Controller panel houses the Allen-Bradley 1756 Process Logic Controller (<b>PLC</b>), I/O and Ethernet modules, as well as Safety modules.
											</p>
											<p>There is a programming port with Ethernet, USB and 120 VAC receptacle located on the left side of the panel.</p>

											<figure style={{ width: '28vw', margin: '20px' }}>
												<img src={PACLoc} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: PAC Location</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<figure style={{ width: '20vw', margin: '20px' }}>
												<img src={PAC} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 2: Programmable Automation Controller (PAC)</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Server Panel" title="Server Panel">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '45vw' }}>
											<div class="d-flex">
												<h2>SERVER PANEL</h2>{' '}
												<a href={SPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>
												The server panel, where the servers are stored, include the KVM switch (which swaps which server is currently visible on the monitor), server power supplies, switches, <b>PLC</b> connections, and the air conditioning unit itself.
											</p>
											<h5>GPU</h5>
											<p>Each GPU server runs two services locally – the SPU service and Image-Capture service for that server. Each Image-Capture service connects the server to a subset of cameras in the inspection cells and handles the capturing of images for those cameras. Those images are then forwarded to the GPU service, which processes the images, detects potential defects, and flags them as regions of interest to be checked by the clustering service.</p>
											<h5>Networked-Attached-Storage (NAS)</h5>
											<p>
												The NAS server is the storage location for common files, folders, scans, and configurations across every other server, it is a centralized “hub” of information storage that all other servers can access. It can be considered the “Main” server; the corresponding <b>HMI</b> has the largest availability of informatic and diagnostic plugins. The NAS server communicates with the <b>PLC</b> to get information about incoming vehicles. It also communicates with the trigger board to read the encoder counts and determine the position of a vehicle in the cell so that the cameras take their images at the correct positions. It receives regions of interest from the GPU service and runs images of them through a machine learning model trained to detect and classify defects. If a defect is detected, it will determine where on the vehicle the defect is so that it can be displayed on the overhead display. It then generates the images for the display once all of the regions of interest are checked.
											</p>

											<figure style={{ width: '28vw', margin: '20px' }}>
												<img src={SPLoc} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Server Panel Locations</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<figure style={{ width: '38vw', margin: '20px' }}>
												<img src={ServerPanel} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 2: Server Panel (Left: Closed, Right: Open)</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Trigger Panels" title="Trigger Panels">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '45vw' }}>
											<div class="d-flex">
												<h2>TRIGGER PANELS (TP1 & TP2)</h2>{' '}
												<a href={TPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>
												The two (2) Trigger Panels <b>TP1</b> & <b>TP2</b> are located on either side of the conveyor near the exit of the inspection cell. They contain the power supply/circuit boards components and trigger board to read the encoder counts and determine the position of a vehicle in the cell so that the cameras take their images at the correct positions.
											</p>

											<figure style={{ width: '28vw', margin: '20px' }}>
												<img src={TPLoc} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Trigger Panel Locations</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<figure style={{ width: '16vw', margin: '20px' }}>
												<img src={TriggerPanel} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 2: Trigger Panel (TP2 shown, TP1 similar)</figcaption>
											</figure>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
